import { useEffect, useState } from 'react';

interface UndoToastProps {
  /** Stable key — bumping it triggers a fresh toast with reset timer. */
  trigger: number;
  message: string;
  onUndo: () => void;
}

const TIMEOUT_MS = 5000;

export function UndoToast({ trigger, message, onUndo }: UndoToastProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (trigger === 0) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), TIMEOUT_MS);
    return () => clearTimeout(t);
  }, [trigger]);

  if (!visible) return null;

  return (
    <output
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 bg-ink text-paper border-2 border-ink rounded-card px-4 py-2 font-hand text-[15px] flex items-center gap-3 shadow-ink-lg"
      data-testid="undo-toast"
    >
      <span>✨ {message}</span>
      <button
        type="button"
        onClick={() => {
          onUndo();
          setVisible(false);
        }}
        className="px-3 py-1 bg-accent-yellow text-ink border-2 border-ink rounded-control font-gloock text-[13px] shadow-ink-sm hover:translate-y-[-1px] transition-transform"
        data-testid="undo-toast-button"
      >
        ↶ Annuler
      </button>
      <button
        type="button"
        onClick={() => setVisible(false)}
        aria-label="Fermer la notification"
        className="text-paper/70 hover:text-paper rounded-full w-6 h-6 grid place-items-center"
      >
        ✕
      </button>
    </output>
  );
}
